import BaseService from "./BaseService";
import { IConfig } from "../interfaces/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { SafeJSONObject } from "../constants/Utils";

class ConfigService extends BaseService {
  constructor() {
    super("config");
  }

  fetchByKey(key: string): Promise<IConfig[]> {
    const formData = new FormData();
    formData.append("key", key);

    return new Promise((resolve, reject) => {
      const cacheKey = `config_key_${key}`;
      const cachedData = this.cache.get(cacheKey);
      if (cachedData) {
        resolve(cachedData);
      } else {
        try {
          this.http.post(`config/read_by_key`, formData).then((data: any) => {
            if (data.code === 200) {
              this.cache.set(cacheKey, data.data);
              resolve(data.data);
            } else reject({ message: data.message });
          });
        } catch (error) {
          reject({ message: "An unexpected error occured!" });
          throw error;
        }
      }
    });
  }

  async fetchAppConfig(): Promise<void> {
    let buyerId = await AsyncStorage.getItem("buyerId");
    let buyer = await AsyncStorage.getItem("buyerData");

    return new Promise((resolve, reject) => {
      this.fetch()
        .then(async (configurations: IConfig[]) => {
          // category and manufacturer views
          const categoryDefault = configurations.find(
            (config) =>
              config.key === `CATEGORY_VIEW_DEFAULT` &&
              config.value === "active"
          );
          const categoryBuyer = configurations.find(
            (config) =>
              config.key === `CATEGORY_VIEW_BUYER.${buyerId}` &&
              config.value === "active"
          );
          const manufacturerDefault = configurations.find(
            (config) =>
              config.key === `MANUFACTURER_VIEW_DEFAULT` &&
              config.value === "active"
          );
          const manufacturerBuyer = configurations.find(
            (config) =>
              config.key === `MANUFACTURER_VIEW_BUYER.${buyerId}` &&
              config.value === "active"
          );

          if (categoryBuyer) {
            await AsyncStorage.setItem("categoryView", "active");
          } else if (categoryDefault) {
            await AsyncStorage.setItem("categoryView", "active");
          } else {
            await AsyncStorage.removeItem("categoryView");
          }

          if (manufacturerBuyer) {
            await AsyncStorage.setItem("manufacturerView", "active");
          } else if (manufacturerDefault) {
            await AsyncStorage.setItem("manufacturerView", "active");
          } else {
            await AsyncStorage.removeItem("manufacturerView");
          }

          // Minimum Order Value (MOV)
          const defaultMovConfig = configurations.find(
            (config) => config.key === `MOV.default`
          );
          const locationMovConfig = configurations.find(
            (config) =>
              config.key === `MOV.${SafeJSONObject(buyer)?.location_id}`
          );

          let mov = `0`;

          if (locationMovConfig) {
            mov = `${locationMovConfig.value}`;
          } else if (defaultMovConfig) {
            mov = `${defaultMovConfig.value}`;
          }
          await AsyncStorage.setItem("MOV", mov);

          // default sales rep phone number
          const phoneRepConfig = configurations.find(
            (config) => config.key === `PHONE_REP`
          );
          if (phoneRepConfig) {
            await AsyncStorage.setItem("PHONE_REP", phoneRepConfig?.value);
          } else {
            await AsyncStorage.setItem("PHONE_REP", "+2349060552941");
          }

          // delivery transaction fee waiver
          const locationTranxFee = configurations.find(
            (config) =>
              config.key ===
              `DELIVERY_BASE.${SafeJSONObject(buyer)?.location_id}`
          );
          const defaultTranxFee = configurations.find(
            (config) => config.key === `DELIVERY_BASE.default`
          );
          if (locationTranxFee) {
            await AsyncStorage.setItem("tranx_fee", locationTranxFee.value);
          } else if (defaultTranxFee) {
            await AsyncStorage.setItem("tranx_fee", defaultTranxFee.value);
          } else {
            await AsyncStorage.removeItem("tranx_fee");
          }

          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  }
}

export const configService = new ConfigService();
export default ConfigService;
